import React from "react";
import "./Loading.css";
import { Logo } from "../../images/Images";

interface SpinnerProps {
  size?: number;
  percent?: number; // Optional percentage for uploads
}

const LoadingComponent: React.FC<SpinnerProps> = ({ size = 200, percent }) => {
  const radius = 40;
  const stroke = 6;
  const normalizedPercent = Math.max(0, Math.min(percent ?? 0, 100));
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (normalizedPercent / 100) * circumference;

  return (
    <div
      className="spinner-container"
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <img
        src={Logo}
        alt="Loading..."
        className="spinner-logo"
        style={{
          width: size,
          height: size,
        }}
      />
      {typeof percent === "number" && (
        <div
          style={{
            marginTop: -30,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <svg width={100} height={100}>
            <circle
              cx={50}
              cy={50}
              r={radius}
              stroke="#e0e0e0"
              strokeWidth={stroke}
              fill="none"
            />
            <circle
              cx={50}
              cy={50}
              r={radius}
              stroke="#089B14"
              strokeWidth={stroke}
              fill="none"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              strokeLinecap="round"
              style={{ transition: "stroke-dashoffset 0.3s" }}
            />
            <text
              x="50%"
              y="50%"
              textAnchor="middle"
              dy=".3em"
              fontSize="20"
              fontWeight="bold"
              fill="#089B14"
            >
              {normalizedPercent}%
            </text>
          </svg>
        </div>
      )}
    </div>
  );
};

export default LoadingComponent;
